<div class="max-w-full flex flex-row overflow-x-auto">
   <div *ngFor="let item of breadcrumbItems"
      class="items inline-flex items-center gap-2 me-2 last:me-0 text-sm leading-3 text-primary-600">
      <svg-icon src="@assets/images/icons/chevron-right.svg" class="arrow inline-grid h-3 w-3"></svg-icon>
      <a *ngIf="item.url.length > 0; else nullBreadcrumb" [routerLink]="item.url" class="whitespace-nowrap overflow-hidden text-ellipsis max-w-44">{{ item.label }}</a>
      <ng-template #nullBreadcrumb>
         <a class="whitespace-nowrap overflow-hidden text-ellipsis max-w-44">{{ item.label }}</a>
      </ng-template>
   </div>
</div>